
<template>
  <article>
   <popup :opened.sync="isPopupOpen" :use-footer="true" :allScroll="true" title="MMAIN-02-01-01-01" @cancel="popupClose">
      <template #content>
        <article class="contents">
          <div class="form nomargin">
            <div class="form-search">
              <div class="form-row">
                <div class="item-desc">{{ $t("MPRS-03-01-01-01") }}</div>
                <div class="item-desc">
                  <div class="form-text-field">
                    <div class="input-text-field">
                      <input type="text" id="textfield1" class="form-control" :placeholder="$t('MDEP-01-01-04-16')" v-model="findWord" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-check-group --type3" v-if="syncContryList.length > 0">
              <div class="form-row nomargin" v-for="(v, i) in syncContryList" :key="i">
                <div class="form-check">
                  <input
                    type="radio"
                    name="choice1"
                    :id="`choice1${i}`"
                    class="form-check-input"
                    @click="selectedContry(v)"
                    :value="v.iSONatnlCd"
                  />
                  <label :for="`choice1${i}`" class="form-check-label">{{ v.iSONatnlCd }}
                     <span class="dec">{{ v.engNatnlName }}</span></label>
                </div>
              </div>
            </div>
            <div class="form-check-group --type3" v-else>
              <div class="empty">
                <div class="empty-img">
                  <i class="icon icon-opt-no"></i>
                </div>
                <strong class="empty-text">{{ /*조회 내역이 없습니다.*/ $t("MINQ-02-03-01-16") }}</strong>
              </div>
            </div>
          </div>
        </article>
      </template>
      <template #footer>
        <button class="btn md gray" @click="popupClose">{{ /*닫기*/ $t("MFXD-01-01-10-05") }}</button>
        <button class="btn md normal" :class="{ disabled: useBtn }" @click="complete">{{ /*사용*/ $t("MFXD-01-01-11-09") }}</button>
      </template>
    </popup>  
  </article>
</template>
<script>
import { mapGetters } from "vuex";
import Common from "@/components/basic/Common";
export default {
  props: {
      opened: { type: Boolean},
      selectedContrys: {
      type: Array,
      default: () => [],
    },
  },
  extends: Common,
  name: "SearchContryPopup",
  computed: {
    ...mapGetters("native", ["getNativeAll"]),
     isPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      }
     }, 
     syncContryList: function () {
      if (this.findWord) {
        return this.contryList.filter(item => {
          return item.engNatnlName.toLowerCase().includes(this.findWord.toLowerCase());
        });
      } else {
        return this.contryList;
      }
    },
  },
  data() {
    return {
      keyword: undefined,
      contryList: {},
      isSelectedContry: undefined,
      findWord: "",
      useBtn: true,
    };
  },
   mounted() {
      this.init();
   },

   watch: {
    selectedContrys: function(v) {
      this.selectedContrys = v;
    },
   },
  methods: {
    init() {
      this.contryList = {};
      this.isSelectedContry = undefined;
      this.searchContry();
    },

    searchContry(keyword) {
      this.$post("/customer/cust/NatnlSearchPop", {natnlName: keyword}, this.searchContrySuc);
    },

    searchContrySuc(res) {
      this.contryList = res.outItem.dataGrid;
    },

    selectedContry(v) {
      this.isSelectedContry = v;
      this.useBtn = false;
    },

    complete() {
      this.$emit("select", this.isSelectedContry.iSONatnlCd);
      this.popupClose();
    },

    popupClose() {
      this.isPopupOpen = false;
      this.findWord = "";
    },
  },
};
</script>